import React from "react";

export default function FieldHint({ children, className = "" }) {
  if (children == null || children === "") return null;
  return (
    <p className={`mt-0.5 text-[11px] text-gray-500 leading-snug ${className}`.trim()}>{children}</p>
  );
}
